module.exports = __webpack_public_path__ + "img/平台1.3c67900e.png";